// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-btn[data-v-37969534]{padding:0 24px!important}.text-blue[data-v-37969534]{color:#1976d2!important}.text-transform-capitalize[data-v-37969534]{text-transform:capitalize}.text-transform-uppercase[data-v-37969534]{text-transform:uppercase}button[data-v-37969534]  .v-icon{font-size:16px;padding:5px}@media(max-width:575px){.v-btn.stepper-button[data-v-37969534]{padding:0 12px!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
